

/**
  * @name AppointmentsController
  * @description Controller for shop appointments
  * @param {unknown} $rootScope unknown
  * @param {unknown} $scope unknown
  * @param {unknown} $q unknown
  * @param {unknown} $stateParams unknown
  * @param {unknown} $state unknown
  * @param {unknown} $interval unknown
  * @param {unknown} $uibModal unknown
  * @param {unknown} ScheduleUtilFactory unknown
  * @param {unknown} SchedulingFactory unknown
  * @param {unknown} Operators unknown
  * @param {unknown} Collector unknown
  * @param {unknown} moment unknown
  * @param {unknown} Events unknown
  * @param {object} Session The session service
  * @param {object} AlertMessages The alerts service
  * @param {object} RESPONSE_MESSAGES The alerts service
  * @param {object} _ The Lodash service
  */
function AppointmentsController(
  $rootScope,
  $scope,
  $q,
  $stateParams,
  $state,
  $interval,
  $uibModal,
  ScheduleUtilFactory,
  SchedulingFactory,
  Operators,
  Collector,
  moment,
  Events,
  Session,
  AlertMessages,
  RESPONSE_MESSAGES,
  _
) {
  let vm = this;

  // Private variables
  let scheduleTimer;

  // Public variables
  vm.events = Events;

  // Public methods
  vm.updateArtistHours = updateArtistHours;
  vm.checkAvailability = checkAvailability;
  vm.prevDay = prevDay;
  vm.nextDay = nextDay;
  vm.goToToday = goToToday;
  vm.today = today;
  vm.open = open;
  vm.setDate = setDate;
  vm.setTall = setTall;
  vm.setCompact = setCompact;
  vm.setSkinny = setSkinny;
  vm.setWide = setWide;
  vm.selectDate = selectDate;
  vm.calcHeight = calcHeight;
  vm.calcHeightRoot = calcHeightRoot;
  vm.calcBlockOffset = calcBlockOffset;
  vm.calcOffset = calcOffset;
  vm.calcScheduleHeight = calcScheduleHeight;
  vm.uiOnParamsChanged = uiOnParamsChanged;
  vm.session = Session;

  // Calendar variables
  vm.date = {
    day: vm.$transition$.params().day,
    month: vm.$transition$.params().month,
    year: vm.$transition$.params().year
  };
  vm.weekdays = ScheduleUtilFactory.daysArray;
  vm.formats = ['dd-MMMM-yyyy', 'YYYY-MM-DD', 'dd.MM.yyyy', 'shortDate'];
  vm.format = vm.formats[0];
  vm.status = {opened: false};

  // Get the Schedule.
  getSchedule(vm.date, {forced: true});

  // Get the Schedule via Timer (no forced update).
  scheduleTimer = $interval(function() {
    getSchedule(vm.date);
  }, 60000);

  /**
   * @name uiOnParamsChanged
   * @description Callback from ui router when params change.
   * @param {object} newParams The param updates.
   */
  function uiOnParamsChanged(newParams) {
    _.assign(vm.date, newParams);
    getSchedule(vm.date, {forced: true});
  }

  /**
   * @name prevDay
   * @description Unknown
   */
  function prevDay() {
    let newDate = moment(vm.date.year + '-' + vm.date.month + '-' +
    vm.date.day, 'YYYY-MM-DD').subtract(1, 'day').format('YYYY-MM-DD');
    vm.date.year = moment(newDate).format('YYYY');
    vm.date.month = moment(newDate).format('MM');
    vm.date.day = moment(newDate).format('DD');
    $state.go('.', vm.date);
  }

  /**
   * @name nextDay
   * @description Unknown
   */
  function nextDay() {
    let newDate = moment(vm.date.year + '-' + vm.date.month + '-' +
    vm.date.day, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD');
    vm.date.year = moment(newDate).format('YYYY');
    vm.date.month = moment(newDate).format('MM');
    vm.date.day = moment(newDate).format('DD');
    $state.go('.', vm.date);
  }

  /**
   * @name goToToday
   * @description Unknown
   */
  function goToToday() {
    let today = {
      year: moment().format('YYYY'),
      month: moment().format('MM'),
      day: moment().format('DD')
    };
    $state.go('.', today);
  }

  /**
   * @name isToday
   * @description Function to return a boolean if the current day is today.
   * @param {object} date The date object from URL params.
   * @return {boolean} TrueFalse
   */
  function isToday(date) {
    let convertedDate = convertDateToMoment(date);
    return moment(convertedDate).startOf('day').unix() ===
    moment().startOf('day').unix();
  }

  /**
   * @name isPast
   * @description Functino to return a boolean if the active day is in the
   * past.
   * @param {object} date The date object from URL params.
   * @return {boolean} TrueFalse
   */
  function isPast(date) {
    let convertedDate = convertDateToMoment(date);
    return moment(convertedDate).startOf('day') < moment().startOf('day');
  }

  /**
   * @name selectDate
   * @description Unknown
   */
  function selectDate() {
    vm.date.year = moment(vm.dateField).format('YYYY');
    vm.date.month = moment(vm.dateField).format('MM');
    vm.date.day = moment(vm.dateField).format('DD');
    $state.go('.', vm.date);
  }

  /**
   * @name today
   * @description Unknown
   */
  function today() {
    vm.dateField = moment().toDate();
  }

  /**
   * @name open
   * @description Unknown
   * @param {Unknown} $event Unknown
   */
  function open($event) {
    vm.status.opened = !vm.status.opened;
  }

  /**
   * @name setDate
   * @description Unknown
   * @param {Unknown} year Unknown
   * @param {Unknown} month Unknown
   * @param {Unknown} day Unknown
   */
  function setDate(year, month, day) {
    vm.dateField = new Date(year, month, day);
  }

  /**
  * @name convertDateToMoment
  * @description Function to convert our URL params date object to a moment
  * object.
  * @param {object} date Our URL params date object.
  * @return {object} convertedDate Returns a moment date object.
  */
  function convertDateToMoment(date) {
    let convertedDate = moment(date.year + '-' + date.month + '-' +
    date.day).format('YYYY-MM-DD');
    return convertedDate;
  }

  /**
   * @name getSchedule
   * @description Function to get all data for the schedule.
   * @param {object} dateObject The date object from URL params.
   * @param {object} request The type of request. If the request is from the
   * interval, this will be undefined.
   * @return {unknown} Unknown
   */
  function getSchedule(dateObject, request) {
    return $q(function(resolve, reject) {
      let date = moment(dateObject.year + '-' + dateObject.month + '-' +
      dateObject.day, 'YYYY-MM-DD');
      vm.lastCalledDate = date;
      // Show the loading status for forced updates
      if (request && request.forced) {
        vm.loading = true;
      }
      // Update dates
      vm.isToday = isToday(vm.date);
      vm.isPast = isPast(vm.date);
      vm.dateDisplay = convertDateToMoment(vm.date);

      SchedulingFactory.fetchScheduleData(date, null)
      .then(function(data) {
        if (moment(vm.lastCalledDate).format('MM-DD-YYYY') ===
        moment(date).format('MM-DD-YYYY')) {
          let schedules = SchedulingFactory.calculateSchedule(
            data.rules,
            data.shopHours,
            data.appointments,
            data.artists
          );
          let validSchedules = [];
          let appointmentTotal = 0;
          let availableTotal = 0;

          for (let i = 0; i < schedules.length; i++) {
            let schedule = schedules[i];

            // Merges schedule blocks together if they're back to back.
            schedule.available =
            ScheduleUtilFactory.mergeConsecutive(schedule.available);
            let availableCount = schedule.available.length;
            let appointmentCount = schedule.appointments.length;

            // Process Appointment/Available Blocks
            if (appointmentCount + availableCount) {
              appointmentTotal += appointmentCount;
              availableTotal += availableCount;

              // Calculate the Revenue total for this Particular Schedule Block.
              let revenueTotal = 0;
              for (let j = 0; j < appointmentCount; j++) {
                let appointment = schedule.appointments[j].appointment;
                if (appointment.last_status.status_name ===
                'Completed' && appointment.price) {
                  revenueTotal += parseFloat(appointment.price);
                }
              }
              schedule.stats = {
                revenue: revenueTotal
              };

              // Determine when the Artist is first Available.
              for (let q = 0; q < schedule.artist_start_end_times.length;
              q++) {
                let interval = schedule.artist_start_end_times[q];
                if (!schedule.first_available ||
                interval.start < schedule.first_available.start) {
                  schedule.first_available = interval;
                }
              }

              // Only add Expired Artists if they have an Appointment.
              if (moment(schedule.artist.association.endDatetime)
              .unix() < moment(date).unix()) {
                if (schedule.appointments.length) {
                  delete schedule.available;
                  delete schedule.artist_start_end_times;
                  delete schedule.first_available;
                  validSchedules.push(schedule);
                }
              } else {
                validSchedules.push(schedule);
              }
            }
          }
          vm.schedules = validSchedules;
          vm.appointmentCount = appointmentTotal;
          vm.availableCount = availableTotal;
          vm.period = calculateShopHours(data.shopHours);
          vm.timelineMarkers = generateTimeline(vm.period);
          vm.loading = false;
          resolve();
        } else {
          resolve();
          vm.loading = false;
        }
      }, function() {
        resolve();
        vm.loading = false;
      });
    });
  }

  /**
   * @name update
   * @description unknown
   * @param {unknown} shopHours Unknown
   * @return {unknown} Unkown
   */
  function calculateShopHours(shopHours) {
    let shopScheduleDetails = {};
    if (shopHours.earliest.rule) {
      shopScheduleDetails = {
        start: shopHours.earliest.start,
        end: shopHours.latest.end,
        duration: shopHours.latest.end
        .diff(shopHours.earliest.start, 'minutes')
      };
    }
    return shopScheduleDetails;
  }

  /**
   * @name updateArtistHours
   * @description Update artist schedule modal
   * @param {unknown} artist Unknown
   */
  function updateArtistHours(artist) {
    let modalInstance;
    if (!vm.isPast) {
      modalInstance = $uibModal.open({
        template: require('../schedule/update/update-schedule.html'),
        animation: true,
        controller: 'ScheduleUpdateController as $ctrl',
        resolve: {
          artist: function() {
            return artist;
          },
          schedule: function() {
            return vm.schedules;
          },
          date: function() {
            return convertDateToMoment(vm.date);
          }
        }
      });
    }
    modalInstance.result.then(function() {
      getSchedule(vm.date, {forced: true});
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function() {
      getSchedule(vm.date, {forced: true});
    });
  }

  /**
   * @name checkAvailability
   * @description Availability lookup for artists
   */
  function checkAvailability() {
    $uibModal.open({
      template:
      require('../schedule/check-availability/check-availability.html'),
      animation: true,
      controller: 'AvailabilityCheckController as $ctrl'
    });
  }

  /**
   * @name calcHeight
   * @description Unknown
   * @param {Unknown} length Unknown
   * @param {Unknown} parent Unknown
   * @return {Unknown} Unknown
   */
  function calcHeight(length, parent) {
    if (!parent) {
      return '100%';
    }
    return 100 * (length / parent) + '%';
  }

  /**
   * @name calcHeightRoot
   * @description Unknown
   * @param {Unknown} length Unknown
   * @return {Unknown} Unknown
   */
  function calcHeightRoot(length) {
    return calcHeight(length, vm.period.duration);
  }

  /**
   * @name calcBlockOffset
   * @description Unknown
   * @param {Unknown} data Unknown
   * @return {Unknown} Unknown
   */
  function calcBlockOffset(data) {
    return calcOffset(data.interval_back_to_shop_start_time);
  }

  /**
   * @name calcOffset
   * @description Unknown
   * @param {Unknown} minutes Unknown
   * @return {Unknown} Unknown
   */
  function calcOffset(minutes) {
    if (!vm.period.duration) {
      return '0';
    }
    return 100 * (minutes / vm.period.duration) + '%';
  }

  /**
   * @name calcScheduleHeight
   * @description Unknown
   * @param {Unknown} modifiers Unknown
   * @return {Unknown} Unknown
   */
  function calcScheduleHeight(modifiers) {
    return Math.ceil(modifiers.length * vm.period.duration) + 'px';
  }

  /**
   * @name generateTimeline
   * @description Unknown
   * @param {Unknown} schedulePeriod Unknown
   * @return {Unknown} Unknown
   */
  function generateTimeline(schedulePeriod) {
    let output = {
      hours: [],
      quarters: []
    };

    for (let time = moment(schedulePeriod.start); time <=
    schedulePeriod.end; time.add(15, 'minute')) {
      let interval = moment(time).format('mm');

      let marker = {
        id: time.unix(),
        time: moment(time),
        duration: time.diff(schedulePeriod.start, 'minutes')
      };

      if (interval % 60 === 0) {
        output.hours.push(marker);
      } else if (interval % 15 === 0) {
        output.quarters.push(marker);
      } else {
        let subAmount = interval % 15;
        if (subAmount) {
          time.subtract(subAmount, 'minute');
        }
      }
    }
    return output;
  }

  // Schedule view defaults
  vm.modifiers = {
    skinny: true,
    compact: true,
    length: 3
  };

  if (!_.isUndefined(Session.viewingMode)) {
    vm.modifiers = {
      skinny: Session.viewingMode.calendarSkinny,
      compact: Session.viewingMode.calendarCompact
    };
    if (Session.viewingMode.calendarCompact === true) {
      vm.modifiers.length = 1.5;
    } else if (Session.viewingMode.calendarCompact === false) {
      vm.modifiers.length = 3;
    }
  }

  /**
   * @name setTall
   * @description Function to set the height of appointment blocks to tall.
   */
  function setTall() {
    let skinny = Session.viewingMode.calendarSkinny;
    let compact = false;
    updateViewMode(skinny, compact);
  }

  /**
   * @name setCompact
   * @description Function to set the height of appointment blocks to compact.
   */
  function setCompact() {
    let skinny = Session.viewingMode.calendarSkinny;
    let compact = true;
    updateViewMode(skinny, compact);
  }

  /**
   * @name setSkinny
   * @description Function to set the width of appointment blocks to skinny.
   */
  function setSkinny() {
    let skinny = true;
    let compact = Session.viewingMode.calendarCompact;
    updateViewMode(skinny, compact);
  }

  /**
   * @name setWide
   * @description Function to set the width of appointment blocks to wide.
   */
  function setWide() {
    let skinny = false;
    let compact = Session.viewingMode.calendarCompact;
    updateViewMode(skinny, compact);
  }

  /**
   * @name udpateViewMode
   * @description Function to update the view mode stored in the operator object.
   * @param {boolean} calendarSkinny Boolean value of the skinny/wide view mode.
   * @param {boolean} calendarCompact Boolean value of the compact/tall view mode.
   */
  function updateViewMode(calendarSkinny, calendarCompact) {
    let collector = Session.collector;
    collector.calendar_skinny = calendarSkinny;
    collector.calendar_compact = calendarCompact;
    Collector.updateProfile(collector).then(function(updatedCollector) {
      Session.viewingMode = {
        calendarSkinny: updatedCollector.calendar_skinny,
        calendarCompact: updatedCollector.calendar_compact
      };
      vm.modifiers.compact = updatedCollector.calendar_compact;
      vm.modifiers.skinny = updatedCollector.calendar_skinny;
      if (updatedCollector.calendar_compact === true) {
        vm.modifiers.length = 1.5;
      } else if (updatedCollector.calendar_compact === false) {
        vm.modifiers.length = 3;
      }
    });
  }

  $scope.$on('clear-data', clear);
  $scope.$on('$destroy', clear);

  /**
   * @name clear
   * @description Unknown
   */
  function clear() {
    $interval.cancel(scheduleTimer);
  }
}

angular
  .module('inkfinder')
  .controller('AppointmentsController', AppointmentsController);



// WEBPACK FOOTER //
// ./components/appointments/appointments.controller.js